import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { StorageService } from '../../../../Services/storage.service';
import {DataService} from '../../../../Services/data.service';
import { NotificationService } from '../../../../Services/notification.service';
import { Title } from '@angular/platform-browser';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { AppConfigService } from '../../../../Services/app-config.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-count-list',
  templateUrl: './count-list.component.html',
  styleUrls: ['./count-list.component.css'],
  standalone: false
})
export class CountListComponent extends ListPageBase implements OnInit {
  constructor(
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: NotificationService,
    private dateFilter: DateFilterService,
    private titleService: Title,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }
  isLoaded = false;
  CountsCount = 0;
  saveList: any;

  vm: any = {
    title: 'Counts',
    Preferences: [],
    permissions: [],
    formRoute: '/inventory/count/form',
    countFilter: { text: '' },
    showAdjustmentsRequired: false,
  };



  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    this.titleService.setTitle(this.vm.title);

    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;
    paramString += '&adjustment_required=false';

    this.tableDataService.getData('Count', paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      this.totalRecords = result.totalRecords;
      this.paginate(false);

      // console.log('list data: ' + JSON.stringify(this.vm.list));
      this.CountsCount = result.totalRecords;
    });
  }

  filter(filter) {
    this.vm.assembleFilter = Object.assign(this.vm.assembleFilter, filter);
    // this.localStorage.StorageSet('countFilter', JSON.stringify(this.vm.assembleFilter));
  }

  adjustmentsRequired(event) {
    if (event) {
      let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
      paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
      paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
      paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
      paramString += '&pageSize=' + this.pageSize;
      paramString += '&adjustment_required=true';

      this.vm.searching = true;
      this.tableDataService.getApiListData('count', paramString).subscribe((result: ResponseModel) => {
        this.vm.searching = false;
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.isLoaded = true;
      });
    } else {
      this.getPagedApiData();
    }
  }

  onNavigate(aID: string) {
    this.router.navigate(['inventory/count/form'], {queryParams: {countId: aID}}).then();
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;
    paramString += '&adjustment_required=false';

    this.tableDataService.getApiListData('Count', paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      this.totalRecords = result.totalRecords;
      this.paginate(false);

      this.vm.searching = false;
      this.isLoaded = true;
    });
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
